'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled, { useTheme } from 'styled-components';
import { isHalloween } from '../operators/isHalloween';
import { Pumpkin } from './Pumpkin';
import { SpiderWebLeft } from './SpiderWebs';
import { TabletAndBelow } from '../themes/mixins';
const ThemedPage = styled.div.withConfig({
  displayName: "ThemedHomePage__ThemedPage",
  componentId: "ra8v0h-0"
})(["background:", ";background-color:", ";", ""], ({
  theme
}) => theme.homePage.background, ({
  theme
}) => theme.homePage.backgroundColor, TabletAndBelow(_t || (_t = _`
    background-image: ${0};
  `), ({
  theme
}) => theme.name === 'defaultTheme' ? 'none' : theme.homePage.backgroundImage));
export const ThemedHomePage = ({
  children
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemedPage, {
    children: [isHalloween(theme) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Pumpkin, {}), /*#__PURE__*/_jsx(SpiderWebLeft, {})]
    }), children]
  });
};